export function initPasswordForm() {
    return {type: "INIT_PASSWORD_FORM"}
}

export function savePasswordData(data){
    return {type: "SAVE_PASSWORD_DATA", payload: data}
}
